<template>
    
</template>

<script>
    export default {
        name: "PreviewCustomFooterSection"
    }
</script>

